import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

type GetNearbyCustomersService = {
  lat: number
  long: number
  distance: number
}

export async function getNearbyCustomersService({
  lat,
  long,
  distance,
}: GetNearbyCustomersService) {
  return await api.get<ResponseAPI>(
    `/clientesproximos/${lat}/${long}/${distance}`,
  )
}
